export const INPUT = 'input';
export const TEXTAREA = 'textarea';
